import {axiosInstance} from '../helpers'


const url = '/sports-enrollment'

const create = params => axiosInstance.create({url: url, params: params})


export const sportsEnrollmentServices = {
  create
}
